import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import {MenuSetForm, MenuSetFormValues} from "../../components/pages/admin/MenuSet/MenuSetForm";
import {menuSetApi} from "../../apis/admin/menu/menuSetApi";
import {useSystemMessage} from "../../hooks/useSystemMessage";
import useAppRouter from "../../hooks/useAppRouter";
import {ApiClientError} from "../../apis/errors";
import {logError} from "../../libs/utils/logError";

export const MenuSetCreatePage: React.FC = () => {
  const defaultValues: MenuSetFormValues = {
    name: '',
    content: '',
    labelSetId: null,
    labelSetName: null,
    menuList: [],
  }
  const {success} = useSystemMessage();
  const [abortController, setAbortController] = useState<AbortController | undefined>();
  const [ apiClientError, setApiClientError] = useState<ApiClientError | null>(null);
  const { goto } = useAppRouter();
  const location = useLocation();

  const clearApiClientError = async (): Promise<void> => {
    setApiClientError(null);
  }

  const onSave = async (data: MenuSetFormValues): Promise<void> => {
    try {
      setAbortController(new AbortController());
      await menuSetApi.create(
        {
          name: data.name,
          content: data.content,
          labelSetId: data.labelSetId,
          menuList: data.menuList,
        },
        { abortSignal: abortController?.signal });

      await success('メニューセットを作成しました。');
      goto('menuSetList')

    } catch (e) {
      await logError(
        location.pathname,
        'メニューセットの作成に失敗しました。',
        e
      );

      if (e instanceof ApiClientError) {
        setApiClientError(e);
        return;
      }

      goto('internalServerError');
    }
  }

  return (
    <>
      <MenuSetForm
        {...{
          defaultValues,
          isEdit: false,
          apiClientError,
          clearApiClientError,
          onSave,
        }}
      />
    </>
  );
}
